import { useRef, useCallback, useEffect } from 'react';

/**
 * @description
 * It returns an array of methods where:
 * - the first clears the interval; It doesn't accept any parameters
 * - the second resets the interval with a new one.
 */
function useTimeout(callback, delay) {
    const savedCallback = useRef(undefined);
    const timeoutId = useRef(undefined);
    const clearTimeout = function () {
        if (timeoutId.current) {
            window.clearTimeout(timeoutId.current);
        }
    };
    const setTimeout = useCallback((timeoutDelay = delay) => {
        clearTimeout();
        function tick() {
            savedCallback.current?.();
        }
        if (timeoutDelay) {
            timeoutId.current = window.setTimeout(tick, timeoutDelay);
        }
    }, [delay]);
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        setTimeout(delay);
        //on unmount clear interval:
        return () => clearTimeout();
    }, [delay, setTimeout]);
    //Return clear interval and setTimeout methods:
    return [clearTimeout, setTimeout];
}

export { useTimeout as default };
//# sourceMappingURL=useTimeout.js.map
